import { useTheme } from "@emotion/react";
import omit from "lodash/fp/omit";
import React from "react";
import ReactSelect from "react-select";

import { ensureArray, useThemeProps } from "../../wsui/base";

import normalizeOptions from "./normalizeOptions";

export default function Select(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "Select" });
  let {
    options,
    value,
    onChange,
    defaultValue,
    multiple = false,
    name,
    id,
    borderRadius = 1,
    padding = 3,
    paddingBlock = padding,
    // paddingInline = padding,
    ...restProps
  } = omit(["paddingInline"], props);
  let normalizedOptions = normalizeOptions(options);

  if (multiple) {
    normalizedOptions = normalizedOptions.filter(
      (option) => option.value !== "",
    );
  }

  return (
    <ReactSelect
      name={name}
      id={id}
      options={normalizedOptions}
      // styles={useSelectStyles()}
      isMulti={multiple}
      value={
        value === undefined
          ? value
          : multiple
          ? value.map((value) =>
              normalizedOptions.find((option) => option.value === value),
            )
          : normalizedOptions.find((option) => option.value === value)
      }
      defaultValue={
        defaultValue === undefined
          ? defaultValue
          : multiple
          ? defaultValue.map((value) =>
              normalizedOptions.find((option) => option.value === value),
            )
          : normalizedOptions.find((option) => option.value === defaultValue)
      }
      onChange={
        onChange &&
        ((newValue, ...args) => {
          newValue = multiple
            ? Array.isArray(newValue)
              ? newValue.map((option) =>
                  typeof option === "object" ? option.value : option,
                )
              : ensureArray(
                  newValue && typeof newValue === "object"
                    ? newValue.value
                    : newValue,
                )
            : newValue && typeof newValue === "object"
            ? newValue.value
            : newValue || "";
          onChange(
            { target: { name, id, value: newValue } },
            newValue,
            ...args,
          );
        })
      }
      isClearable
      styles={{
        control: (styles) => ({ ...styles }),
      }}
      theme={(componentTheme) => ({
        ...componentTheme,
        borderRadius: theme.getLength(borderRadius),
        spacing: {
          ...componentTheme.spacing,
          controlHeight: `calc(${theme.getLength(paddingBlock)} * 2 + 1lh)`,
        },
        colors: {
          ...componentTheme.colors,
          primary: theme.getColor("primary"),
          primary75: theme.getColor("primary.-100"),
          primary50: theme.getColor("primary.200"),
          primary25: theme.getColor("primary.100"),
          danger: theme.getColor("error"),
          dangerLight: theme.getColor("error.100"),
          neutral0: theme.getColor("gray.0"),
          neutral5: theme.getColor("gray.50"),
          neutral10: theme.getColor("gray.100"),
          neutral20: theme.getColor("gray.200"),
          neutral30: theme.getColor("gray.300"),
          neutral40: theme.getColor("gray.400"),
          neutral50: theme.getColor("gray.500"),
          neutral60: theme.getColor("gray.600"),
          neutral70: theme.getColor("gray.700"),
          neutral80: theme.getColor("gray.800"),
          neutral90: theme.getColor("gray.900"),
        },
      })}
      {...restProps}
    />
  );
}
